
export class EmailGeneratedWithNotificationTemplate {
    public selectedNotificationTemplateId: number;
    public selectedNotificationTemplateName: string;

    public subjectText: string;
    public bodyText: string;
}
